<template>
    <div>
        <form id="formEditField"  @submit.prevent="onSubmit">

            <label>Área de Atuação *</label>
            <div class="form-group flex-row">
                <input type="text"
                       class="form-control"
                       v-model="form.name"
                       required
                >
            </div>

            <label>Crédito *</label>
            <div class="form-group flex-row">
                <input type="number"
                       class="form-control"
                       v-model="form.credit_value"
                       :min='1'
                       :max='99999999999'
                       required
                >
            </div>
            
            <button class="btn btn-md btn-primary">Atualizar</button>
            <a href="/admin/configuracoes/fields" class="btn btn-md btn-default">Voltar</a>
        </form>
    </div>
</template>

<script>
import Form from 'form-backend-validation';

export default {
  props: {
    field: {
        type: Object,
        required: true,
    },
  },
  data() {
      return {
          form: new Form({
              ...this.field,
          }),
      };
  },
  mounted() {
  },
  methods: {
      onSubmit() {
          this.form.patch(`/admin/configuracoes/fields/${this.field.id}`)
            .then(() => {
                toastr.success('Área de atuação atualizada com sucesso');
                location.href = '/admin/configuracoes/fields';
            }).catch(() => {
                toastr.error('Erro ao atualizar área de atuação');
            });
      }
  }
}
</script>